<template>
  <div>
    <list-header :title="$t('filter.filter')" hide-show-categories-button>
      <template v-if="!$vuetify.display.mobile" #filter>
        <sf-icon-button
          :icon="mdiClose"
          color=""
          :aria-label="$t('closeFilter')"
          @click="$emit('close')"
        />
      </template>
    </list-header>
    <div v-show="isLoading" class="mt-2">
      <slot name="skeleton" />
    </div>
    <div v-show="!isLoading">
      <div
        ref="filterContainer"
        class="overflow-y-auto scrollbar mt-2 pr-1"
        :style="'height: calc(100vh - ' + offset + 'px)'"
      >
        <slot name="filter" />
      </div>
      <div class="d-flex align-center justify-center mt-2">
        <sf-text-button :disabled="isResetDisabled" @click="$emit('resetFilter')">
          {{ $t('filter.resetFilter') }}
        </sf-text-button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import SfIconButton from '@/components/button/SfIconButton.vue'
import SfTextButton from '@/components/button/SfTextButton.vue'
import ListHeader from '@/components/list/ListHeader.vue'
import { containerHeight } from '@/utils/containerHeightHelper'
import { mdiClose } from '@mdi/js'
import { ComponentPublicInstance, ref } from 'vue'

defineProps({
  isLoading: {
    type: Boolean,
    required: true
  },
  isResetDisabled: {
    type: Boolean,
    default: false
  }
})

defineEmits<{
  close: []
  resetFilter: []
}>()

const bottomMargin = 77
const filterContainer = ref<ComponentPublicInstance<HTMLElement>>()
const { offset } = containerHeight(filterContainer, bottomMargin)
</script>
